import { paths } from 'src/component-paths/component-paths';

export interface QuestionnaireTemplateConfig {
  id: number;
  title: string;
  sectionPath: string;
  routeSection: string;
  addPermissions?: string[];
}

export const QUESTIONNAIRE_TEMPLATE_CONFIGS: QuestionnaireTemplateConfig[] = [
  {
    id: 1,
    title: 'Social History Questionnaire',
    sectionPath: paths.socialQuestionnaireAmen,
    routeSection: paths.initialAssessments,
    addPermissions: ['a-sqa'],
  },
  {
    id: 2,
    title: 'Fast Protocol Questionnaire',
    sectionPath: paths.fastProtocolQuestionnaireMediterrenean,
    routeSection: paths.initialAssessments,
    addPermissions: ['a-fpm'],
  },
  {
    id: 3,
    title: 'Stroke Score Questionnaire',
    sectionPath: paths.strokeScoreQuestionnaireMediterrenean,
    routeSection: paths.initialAssessments,
    addPermissions: ['a-nih'],
  },
  {
    id: 4,
    title: "Parkinson's disease questionnaire",
    sectionPath: paths.parkinsonsQuestionnaire,
    routeSection: paths.departmentalQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 5,
    title: 'Geriatric Depression Scale',
    sectionPath: paths.geriatricDepressionScale,
    routeSection: paths.departmentalQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 6,
    title: "Beck's Depression Inventory Questionnaire",
    sectionPath: paths.becksDepressionInventory,
    routeSection: paths.departmentalQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 7,
    title: 'Oral and clinical assessment of deposition',
    sectionPath: paths.oralClinicalAssessmentOfDeposition,
    routeSection: paths.departmentalQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 8,
    title: 'Berg Balance Scale',
    sectionPath: paths.bergBalanceScale,
    routeSection: paths.departmentalQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 9,
    title: 'Patient Assessment Card',
    sectionPath: paths.patientAssessmentCard,
    routeSection: paths.departmentalQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 10,
    title: 'SLDC',
    sectionPath: paths.sldcQuestionnaire,
    routeSection: paths.departmentalQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 11,
    title: 'SLAG',
    sectionPath: paths.slagQuestionnaire,
    routeSection: paths.departmentalQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 12,
    title: 'Douleur Neuropathique 4 (DN4)',
    sectionPath: paths.dn4,
    routeSection: paths.pilotQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 13,
    title: 'EQ-5D',
    sectionPath: paths.eq5d,
    routeSection: paths.pilotQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 14,
    title: 'MOBID',
    sectionPath: paths.mobid,
    routeSection: paths.pilotQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 15,
    title: 'PAINAD',
    sectionPath: paths.painad,
    routeSection: paths.pilotQuestionnaires,
    addPermissions: ['a-sqa'],
  },
  {
    id: 16,
    title: 'PACSLAC-II',
    sectionPath: paths.pacslac2,
    routeSection: paths.pilotQuestionnaires,
    addPermissions: ['a-sqa'],
  },
];

export function getQuestionnaireTemplateConfig(
  templateId?: number | string | null
): QuestionnaireTemplateConfig | undefined {
  const normalizedId =
    templateId === undefined || templateId === null
      ? undefined
      : Number(templateId);

  return QUESTIONNAIRE_TEMPLATE_CONFIGS.find(
    (config: QuestionnaireTemplateConfig) => config.id === normalizedId
  );
}

export function getQuestionnaireTemplateConfigByPath(
  sectionPath?: string | null
): QuestionnaireTemplateConfig | undefined {
  return QUESTIONNAIRE_TEMPLATE_CONFIGS.find(
    (config: QuestionnaireTemplateConfig) => config.sectionPath === sectionPath
  );
}
